export default __webpack_public_path__ + "static/media/US_flag.4b8f7296.svg";